import React, { useState, forwardRef, useEffect } from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "20px",
    width: "80px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "20px",
      backgroundColor: theme.palette.common.white,
      color: "#a989ee",
      height: "36px",
    },
    "& .MuiOutlinedInput-input": {
      padding: 0,
      margin: 10,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.grey[400],
    },
  },
}));

const QuantityInput = forwardRef(
  ({ customStyles, onBlur, onChange, value, testId, ...otherProps }, ref) => {
    const [inputValue, setInputValue] = useState(value || '');
    const classes = useStyles();
    useEffect(() => {
      setInputValue(value || "");
    }, [value]);

    const isNumbers = (str) => {
      if (str === "" || str === "-") return true;
      return /^-?[0-9]+$/.test(str);
    };

    const onInputChange = (e) => {
      const newValue = e.target.value;
      if (isNumbers(newValue)) {
        setInputValue(newValue);
        if (onChange) {
          onChange(newValue);
        }
      }
    };

    return (
      <TextField
        inputRef={ref}
        variant="outlined"
        size="small"
        onBlur={onBlur}
        onChange={onInputChange}
        InputProps={{ inputProps: { min: 0, "data-testid": testId } }}
        className={`${classes.root} ${customStyles}`}
        {...otherProps}
        value={inputValue}
        {...otherProps}
      />
    );
  }
);

QuantityInput.propTypes = {
  customStyles: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  testId: PropTypes.string,
};

export default QuantityInput;
